<template>
    <div class="shopping-cart__loader">
        <div
        class="loader text-xxxxl loader--brand-primary"
        :class="{
            'loader--centered': centered,
            'loader--brand-primary': color === 'brand-primary'
        }"
        >
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      color: String,
      centered: Boolean
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .shopping-cart__loader {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    z-index: 10;
  }
  .loader {
    display: inline-block;
    position: relative;
    width: 1em;
    height: 1em;
    zoom: 3;
  }
  .loader div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 0.9em;
    height: 0.9em;
    margin: 0.1em;
    border: 0.1em solid #fff;
    border-radius: 50%;
    animation: loader 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #fff transparent transparent transparent;
  }
  .loader div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .loader div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .loader div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes loader {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .loader--brand-primary div {
    border-color: var(--color-red) transparent transparent transparent;
  }
  .loader--centered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
  </style>
  